import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {LibContentCardComponent} from '@lib-modules/cards/components/content-card/content-card.component';
import {LibLazyImageModule} from '@components/image/modules/lazy-image/lib-lazy-image.module';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {RouterModule} from '@angular/router';
import {LibMatchCardComponent} from './components/match-card/match-card.component';
import {EventCardComponent} from '@lib-modules/cards/components/event-card/event-card.component';
import {LibUtilsPipesModule} from '@utils/pipes/lib-utils-pipes.module';
import { NewsCardComponent } from './components/news-card/news-card.component';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ShopItemCardComponent } from './components/shop-item-card/shop-item-card.component';
import { ContentCardBackgroundComponent } from '@lib-modules/cards/components/content-card-background/content-card-background.component';

@NgModule({
  declarations: [
    LibContentCardComponent,
    LibMatchCardComponent,
    EventCardComponent,
    NewsCardComponent,
    ShopItemCardComponent,
    ContentCardBackgroundComponent,
  ],
  imports: [
    CommonModule,
    LibLazyImageModule,
    SharedNewsModule,
    RouterModule,
    LibUtilsPipesModule,
    MatIconModule,
    MatTooltipModule,
  ],
  exports: [
    LibContentCardComponent,
    LibMatchCardComponent,
    EventCardComponent,
    NewsCardComponent,
    ShopItemCardComponent,
  ]
})
export class LibCardsModule { }
